export default "__VITE_ASSET__Jt4lYAjk__"